import React, { Fragment, useEffect } from "react"
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const Personaly = ({})=> {

  const currentUser = security.currentUserValue;
  const apiKey      = 'eff6966bf7ca7ce8c0e861a71e5fa46c';

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/offers" showLogo={true} />

      <iframe
        style={{width:"100%", height:"92vh", border:0, padding:0, margin:0}}
        scrolling="yes"
        frameBorder="0"
        src={`https://persona.ly/widget/?appid=${apiKey}&userid=${currentUser.id}`}
      ></iframe>

    </Fragment>
  );
};

export default Personaly;
